import { axios } from "../../helpers/axios";
import { COMPANY_URL,PAYMENT_URL,ASSIGN_URL } from "./companyConstants";

export const api_get_company_list_url = async (page, qs, qn, limit) => {
    return axios.get(COMPANY_URL, { params: {page, qs, qn,limit}});
};

export const api_get_payment_terms_list_url = async () => {
    return axios.get(PAYMENT_URL);
};
export const api_create_company_url = async (data) => {
    return axios.post(COMPANY_URL, data);
};

export const api_update_company_url = async (company_id,updated_data) => {
    return axios.put(COMPANY_URL + "/" + company_id,updated_data);
};

export const api_activate_deactivate_company_url = async (company_id,updated_data) => {
    return axios.patch(COMPANY_URL +  "/update/"+ company_id + "/" + updated_data);
};

export const api_get_company_details_url = async (company_id) => {
    return axios.get(COMPANY_URL +  "/" + company_id);
};

export const api_get_company_assign_process_url = async (company_id,updated_data) => {
    return axios.put(ASSIGN_URL +  "/" + company_id,updated_data);
};